export const ALGOLIA_BYTE_LIMIT = 512

export function isQueryTooLong(query: string, byteLimit: number = ALGOLIA_BYTE_LIMIT) {
  return new Blob([query]).size > byteLimit
}

const TRUNCATED_QUERY_LENGTH = 450

// Algolia rejects a whole request whose query is past its byte limit, so a long query is cut
// short and the search still runs.
export function truncatedLongQuery(query: string): string {
  if (!isQueryTooLong(query)) {
    return query
  }
  return query.substring(0, TRUNCATED_QUERY_LENGTH)
}
